import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchInventoryItems } from "../../../actions/inventoryActionsV2";

const useStats = () => {
  const dispatch = useDispatch();
  const unreviewedRecommendationsCount = useSelector(
    (state) => state.aiSkuMappings?.data?.unreviewedRecommendationsCount,
  );

  useEffect(() => {
    dispatch(fetchInventoryItems({ filters: { noMapping: true } }));
  }, [dispatch]);
  const {
    inventory: { count: totalUniqueUnmappedSupplier },
  } = useSelector((state) => state.inventory);

  const approvedRecommendations = useSelector(
    (state) => state.aiSkuMappings?.data?.approvedRecommendations,
  );
  const uniqueSupplierProductIds = useMemo(() => {
    if (!approvedRecommendations) return [];
    return Array.from(
      new Set(approvedRecommendations.map((item) => item.supplierProductId)),
    );
  }, [approvedRecommendations]);
  return {
    unmappedLabProductsCount:
      totalUniqueUnmappedSupplier - uniqueSupplierProductIds.length,
    unreviewedRecommendationsCount,
  };
};

export default useStats;
